const manageEditCompanyPhraseBooks = 'manage.editCompany.phraseBooks'

const manageEditCompanyPhraseBooksConfig = {
  url: '/phrase-books',
  component: 'companyPhraseBooks',
}

export { manageEditCompanyPhraseBooks, manageEditCompanyPhraseBooksConfig }
